import gql from "graphql-tag";

export const GET_REGISTRATION_NUMBER_DETAILS = gql`
  query getRegistrationNumberDetails(
    $registrationNumber: String!
    $formId: String!
  ) {
    getRegistrationNumberDetails(
      registrationNumber: $registrationNumber
      formId: $formId
    ) {
      registrationNumber
      status
      validityStartDate
      validityEndDate
      empBusinessName
      tempneedStart
      empFein
      tempneedEnd
      jobTitle
      jobMsa
      numberOfWorkers
      originatingCaseNumber
      socCode
      socTitle
      tempneedNature
      tempneedDescription
      linkedCases {
        caseNumber
        externalStatus
        submittedDate
        empBusinessName
        agentName
        tempneedStart
        tempneedEnd
        swaJoborderStatename
        isActive
      }
    }
  }
`;
